<template>
  <div class="header">
    <div class="header__logo">
      <a href="https://www.bsac.co.jp/" target="_blank"
        ><img
          src="../../../../images/common/header_logo.png"
          alt="BSAC JAPAN"
          class="header__logo-image"
      /></a>
    </div>
    <div class="header__logo">
      <p class="header__env-name">{{ envName }}</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * 環境名を取得する
     */
    envName: function () {
      return process.env.ENV_NAME;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 120px;
  background: #fff;
  position: fixed;
  display: flex; //block;
  align-items: flex-start;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1; // ラジオボタンがヘッダーの手前に表示されるための対応

  &__logo {
    width: 300px;
    height: auto;
    margin: 18px 0 0 40px;
    padding: 30px 0 30px 0;
    position: relative;
  }

  &__logo-image {
    width: 100%;
    height: auto;
    display: block;
  }

  &__env-name {
    font-size: 2rem;
    color: #ff0000;
    font-weight: bold;
  }
}

@media screen and (max-width: 1024px) {
  .header {
    height: 80px;

    &__logo {
      width: 200px;
      margin: 10px 0 0 10px;
      padding: 15px 0 15px 0;
    }

    &__env-name {
      font-size: 1.2rem;
    }
  }
}
</style>
